import { render, staticRenderFns } from "./ProjectPlanStocks.vue?vue&type=template&id=50f6d2fa&"
import script from "./ProjectPlanStocks.vue?vue&type=script&lang=js&"
export * from "./ProjectPlanStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports